module.exports = __webpack_public_path__ + "static/graph-morphologies-23f18da9428d132ab6cc9f125be258d3.jpeg";